/**
 *
 * 全局对角色区分的mixins
 *
 *  1.普通用户  2. 管理员-大市场人员 3. 金融机构  4. 投资机构 5. 担保机构
 */

export const isTypes = {
  computed: {
    // 普通用户
    isCommon() {
      return JSON.parse(this.$store.state.userInfo).type === 1;
    },
    // 大市场人员--管理员
    isLargeMarket() {
      return JSON.parse(this.$store.state.userInfo).type === 2;
    },
    // 金融机构
    isFinance() {
      return JSON.parse(this.$store.state.userInfo).type === 3;
    },
    // 投资机构
    isInvest() {
      return JSON.parse(this.$store.state.userInfo).type === 4;
    },
    // 担保机构
    isWarrant() {
      return JSON.parse(this.$store.state.userInfo).type === 5;
    },
    // 收劵机构
    isCollecting() {
      return JSON.parse(this.$store.state.userInfo).type === 6;
    }
  },
  created() {},
  data() {
    return {};
  },
  methods: {}
};
